import { AuthUser } from 'auth/types'

export const convertToIntercomUser = (user: AuthUser) => ({
  customAttributes: {
    fairhq_role: user?.roles?.[0],
  },
})
